/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ WHAT A DOCUMENT MAY BE, ONCE, FOR ALL FOUR SUBJECTS.                 │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * Named by the product owner on 15 Sep: *"txt, pdf, xlsx, csv, json, md"*, then widened the same
 * day with *"doc, docx, xls, jpg, png, webp"*.
 *
 * ⚠️ **`.jpeg` is in the list and nobody asked for it**, because it is `.jpg` — the same format
 * under the name every camera and half of Windows writes. Refusing it would be a filter that is
 * right about the format and wrong about the file.
 *
 * ⚠️⚠️ **THERE WERE THREE OF THESE LISTS AND THEY ALREADY DISAGREED.** `PERSON_FILES` took PDF,
 * three image types and a .docx; `ATTACHMENT_TYPES` in the line-item detail took the same plus
 * .xlsx; the leave request had a third copy. None of them took a .txt, a .csv, a .json or a .md —
 * so dragging a text file onto a task produced nothing at all, with no refusal and nothing in any
 * log, because the picker filtered it out before the request existed. Reported as *"upload doesn't
 * work"*, which is exactly what it looks like from outside.
 *
 * ⚠️⚠️ **THE EXTENSIONS ARE LOAD-BEARING AND THE MIME TYPES ARE NOT ENOUGH.** `accept` matches a
 * file against either, and the operating system's idea of a `.md` or a `.csv` varies by machine —
 * Windows reports `.md` as `application/octet-stream` and `.csv` as `application/vnd.ms-excel` on a
 * box with Excel installed. An extension is the one thing both ends agree on.
 *
 * ⚠️ **This is a FILTER, not a security boundary, and the server does not share it.** `file.service`
 * restricts types only for pictures and for the Agent (which can read nothing but tables); every
 * other target accepts what ClamAV passes. So this list narrows what somebody is OFFERED, and
 * widening it needs no server change — which is also why it must not pretend to be a whitelist.
 */
export const DOCUMENT_FILES = [
  /* Text and data. */
  '.txt',
  '.md',
  '.csv',
  '.json',
  'text/plain',
  'text/markdown',
  'text/csv',
  'application/json',

  /* Documents. ⚠️ `.doc` and `.xls` are the pre-2007 binary formats and have their own types —
     they are not `.docx` and `.xlsx` with a shorter extension, and a list carrying only the
     modern pair silently refuses every file anybody has kept since 2003. */
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

  /* Pictures — a screenshot of the bug is the commonest attachment there is. */
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  'image/jpeg',
  'image/png',
  'image/webp',
] as const;

/**
 * Just the extensions, for a sentence.
 *
 * ⚠️ Derived from the list rather than typed out again: a hint that names a format the picker
 * refuses is worse than no hint, and two hand-kept lists is how that happens.
 */
export const DOCUMENT_EXTENSIONS = DOCUMENT_FILES.filter((entry) => entry.startsWith('.'));
